export default __webpack_public_path__ + "static/media/diligence.5eb394c8.png";